import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = { copiedText: { type: String, default: "Copied" } }

  copy() {
    const text = this.sourceTarget?.textContent
    if (!text) return

    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text)
    } else {
      this.fallbackCopy(text)
    }

    this.flashCopied()
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "true")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
  }

  flashCopied() {
    if (!this.hasButtonTarget) return

    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = this.copiedTextValue
    this.buttonTarget.disabled = true

    setTimeout(() => {
      this.buttonTarget.textContent = original
      this.buttonTarget.disabled = false
    }, 1200)
  }
}
